/** Keep first and last ticks, then every nth so a 31-day month does not smear. */
export const MAX_AXIS_LABELS = 8;

export const shouldShowAxisLabel = (index: number, count: number): boolean => {
  if (count <= MAX_AXIS_LABELS) return true;
  if (index === 0 || index === count - 1) return true;
  const step = Math.ceil((count - 1) / (MAX_AXIS_LABELS - 1));
  return index % step === 0;
};
